import { initAxios, initAxiosLogin } from 'service/axios';

export const getPublicKey = () => initAxiosLogin().then(
  (axios) => axios.get('/auth/public-key')
);

// eslint-disable-next-line import/prefer-default-export
export const login = (payload) => initAxiosLogin().then(
  (axios) => axios.post('/auth/login', payload)
);

export const authInfo = () => initAxios().then(
  (axios) => axios.get('/auth/info')
);

export const resetPassword = (payload) => initAxios().then(
  (axios) => axios.post('/auth/reset-password', payload)
);
